var _path, _g, _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeveralWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_433_7950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04047 27.4278L16.556 11.0793C17.8878 8.5226 21.5341 8.48897 22.9127 11.0207L31.8154 27.3692C33.1222 29.7689 31.3851 32.6927 28.6526 32.6927H11.2344C8.53119 32.6927 6.79167 29.8253 8.04047 27.4278Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5979 10.5802L7.08229 26.9287C5.45884 30.0455 7.72022 33.7731 11.2344 33.7731H28.6526C32.2048 33.7731 34.463 29.9722 32.7642 26.8525L23.8616 10.504C22.0693 7.21278 17.3291 7.25649 15.5979 10.5802Z",
    stroke: "white",
    strokeWidth: 2.16076,
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7005,
    cy: 26.6575,
    r: 1.08038,
    fill: "#F6F6F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.6201,
    y: 15.6416,
    width: 2.16076,
    height: 9.16026,
    rx: 1.08038,
    fill: "#F6F6F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_433_7950",
    x: 0.662906,
    y: 2.17878,
    width: 38.5616,
    height: 37.4764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.40085
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_433_7950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_433_7950",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeveralWarning);
export default __webpack_public_path__ + "static/media/several-warning.747949260132b945df56ff5b97b40378.svg";
export { ForwardRef as ReactComponent };